import { useState } from 'react';
import { uploadImage } from '../services/content';

export default function AdminImageField({ label, value, onChange }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function handleUpload(event) {
    const file = event.target.files?.[0];
    if (!file) return;
    setBusy(true);
    setError('');
    try {
      onChange(await uploadImage(file));
    } catch (reason) {
      setError(reason.message);
    } finally {
      setBusy(false);
      event.target.value = '';
    }
  }

  return (
    <div className="admin-image-field">
      <label className="form-field">
        <span>{label} URL</span>
        <input type="url" value={value || ''} onChange={(event) => onChange(event.target.value)} />
      </label>
      <label className="admin-upload">
        <span>{busy ? 'Uploading…' : 'Or upload an image'}</span>
        <input type="file" accept="image/png,image/jpeg,image/webp,image/gif" onChange={handleUpload} disabled={busy} />
      </label>
      {value && <img src={value} alt={`Preview: ${label}`} loading="lazy" />}
      {error && <p role="alert">{error}</p>}
    </div>
  );
}